<div class="stats-darkness" [ngClass]="{ 'stats-darkness--visible': !!transfer.formData() }" (click)="transfer.formData.set(null)"></div>

<div class="stats-menu-fixed" [ngClass]="{ 'stats-menu-fixed--visible': !!transfer.formData() }">
  <app-stats-fields-form class="stats-menu-fixed__content"></app-stats-fields-form>
  <button mat-fab class="stats-menu-fixed__close" (click)="transfer.formData.set(null)"><mat-icon>close</mat-icon></button>
</div>

<div class="stats-menu-spacer" [ngClass]="{ 'stats-menu-spacer--visible': !!transfer.formData() }"></div>
<div class="stats-row">
  <app-stats-series></app-stats-series>
  <app-stats-series type="pie"></app-stats-series>
</div>
